<div id="catchweight-tooltip">
  <p>{{ message }}</p>
</div>
